import { render, staticRenderFns } from "./popContentList.vue?vue&type=template&id=70621c6f&scoped=true"
import script from "./popContentList.vue?vue&type=script&setup=true&lang=js"
export * from "./popContentList.vue?vue&type=script&setup=true&lang=js"
import style0 from "./popContentList.vue?vue&type=style&index=0&id=70621c6f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70621c6f",
  null
  
)

export default component.exports